// src/group/group-label-context.ts
import { createContext } from "react";
var GroupLabelContext = createContext(void 0);

export {
  GroupLabelContext
};
